<template>
  <el-autocomplete v-model="values"
                   :disabled="disabled"
                   :fetch-suggestions="search"
                   clearable
                   @blur="blur"
                   @clear="clearItem"
                   @select="selectItem"
                   :value-key="itemName"
                   :trigger-on-focus="true"
                   :placeholder="placeholder"
                   style="width: 500px"/>
</template>

<script>

export default {
  name: 'CustomerMassageAutoComplete',
  props: {
    value: { type: String, default: '' },
    customerId: { type: String, default: '' },
    placeholder: { type: String, default: '请输入' },
    disabled: { type: Boolean, default: false }
  },
  data() {
    return {
      values: '',
      itemName: 'value'
    };
  },
  created() {
    this.values = this.value;
  },
  watch: {
    value() {
      this.values = this.value;
    }
  },
  methods: {
    async search(qs, cb) {
        let query = qs.split('/')[0];
        let results = [];
        let url = `/customer/wechat/customer/app?customerBind=true&status=1&custInfoAggregation=${query}&pageSize=99`;
        if (this.customerId) {
            url += `&customerIds=${this.customerId}`;
        }
        const { data } = await this.qGet(url);
        let index = 0;
        data.datas.forEach(item => {
            item.custInfos.forEach(i => {
                if (i.custName.indexOf(query) !== -1 || item.name.indexOf(query) !== -1 || item.phone.indexOf(query) !== -1) {
                    results.push({
                        ...item,
                        custInfo: i,
                        tableId: index,
                        value: `${i.custName}/${item.name}/${item.phone}`,
                        label: `${i.custName}/${item.name}/${item.phone}`
                    })
                    index = index + 1;
                }
            })
        });
        cb(results);
    },
    blur() {
      this.values = this.value;
    },
    clearItem() {
      this.$emit('clear');
    },
    async selectItem(item) {
      if (item !== null) {
        this.$emit('update:value', item[this.itemName]);
        this.$emit('setValue', {
          ...item
        });
      }
    }
  }
};
</script>

<style lang="scss" scoped>

</style>
